import React from "react";
import NavBar from "../components/Navbar/Navbar";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

//import '../../src/assets/dist/css/adminlte.min.css';

function DashboardLayout({ children }) {
  return (
    <>
      <Header />
      <NavBar />

      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="container-fluid">{/* /.row */}</div>
          {/* /.container-fluid */}
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">{children}</div>
          {/* /.container-fluid */}
        </section>
        {/* /.content */}
      </div>
      <Footer />
    </>
  );
}
export default DashboardLayout;
